import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Row, Steps } from 'antd'
import PublicationStatus from './PublicationStatus'
import { useUploadProcess } from '../context/UploadProcessProvider'

const DESCRIPTIONS = ['Header.Upload', 'Header.Royalties', 'Header.Information']
const TABS_DESCRIPTIONS = ['Header.Author', 'Header.Details']

const STATUS_FINISH = 'finish'
const STATUS_WAIT = 'wait'
const STATUS_PROCESS = 'process'

const Stepper = ({ currentStep, currentTab }) => {
  const { t } = useTranslation()
  const { steps, tabs } = useUploadProcess()

  const defineStatus = (items, idx, current) => {
    if (items[idx]) return STATUS_FINISH
    else {
      if (idx === current) return STATUS_PROCESS
      else return STATUS_WAIT
    }
  }

  const showTooltip = steps[1] // if second step is done
  const makeTooltipOpenned = currentStep === 1 // if current step is 'Contract accepted'
  const showDetailsTabs = currentStep === 2 && !steps[2] // if current step is Details
  return (
    <>
      {showTooltip && <PublicationStatus open={makeTooltipOpenned} />}
      <Steps
        type="navigation"
        size="medium"
        direction="horizontal"
        responsive={false}
        current={currentStep}
        className="stepper site-navigation-steps"
        items={steps.map((step_status, idx) => ({
          icon: (
            <img
              alt="step status image"
              src={
                step_status
                  ? 'images/stepper/checked.svg'
                  : `images/stepper/grin_ico_stepper_${idx}.svg`
              }
            />
          ),
          title: idx + 1,
          description: <span> {t(DESCRIPTIONS[idx])}</span>,
          status: defineStatus(steps, idx, currentStep),
        }))}
      />
      {showDetailsTabs && (
        <Row>
          <Col xl={9} sm={8}>
            <Steps
              type="navigation"
              size="medium"
              direction="horizontal"
              responsive={false}
              current={currentTab}
              className="stepper tabs site-navigation-steps"
              items={tabs.map((step_status, idx) => ({
                icon: (
                  <img
                    alt="tab image"
                    src={
                      step_status
                        ? 'images/tabs/checked.svg'
                        : `images/tabs/tab_${idx}.svg`
                    }
                  />
                ),
                description: <span>{t(TABS_DESCRIPTIONS[idx])}</span>,
                status: defineStatus(tabs, idx, currentTab),
              }))}
            />
          </Col>
        </Row>
      )}
    </>
  )
}

export default Stepper
